// import { useEffect, useState } from 'react';

// export const useGenerateOneLink = () => {
//   const [oneLink, setOneLink] = useState('');

//   useEffect(() => {
//     if (window.AF_SMART_SCRIPT) {
//       console.log('AF_SMART_SCRIPT is available');

//       const oneLinkURL = 'https://zodiaq.onelink.me/kmvm';
//       const webReferrer = 'af_channel';
//       const mediaSource = { keys: ['utm_source'], defaultValue: 'organic_landing' };
//       const campaign = { keys: ['utm_campaign'] };
//       const adSet = { keys: ['utm_content'] };
//       const af_c_id = { paramKey: 'af_c_id', keys: ['campaign_id'] };
//       const custom_ss_ui = { paramKey: 'af_ss_ui', defaultValue: 'true' };

//       const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
//         oneLinkURL,
//         webReferrer,
//         afParameters: {
//           mediaSource,
//           campaign,
//           adSet,
//           afCustom: [af_c_id, custom_ss_ui],
//         },
//       });

//       setOneLink(result);
//       console.log('OneLink URL:', result);
//     }
//   }, []);

//   return oneLink;
// };

import { useEffect, useState } from 'react';

export const useGenerateOneLink = () => {
  const [oneLink, setOneLink] = useState('');

  useEffect(() => {
    if (window.AF_SMART_SCRIPT) {
      console.log('AF_SMART_SCRIPT is available');

      const oneLinkURL = 'https://zodiaq.onelink.me/kmvm';
      const webReferrer = 'af_channel';
      const mediaSource = { keys: ['utm_source'], defaultValue: 'organic_landing' };
      const campaign = { keys: ['utm_campaign'] };
      const adSet = { keys: ['utm_content'] };
      const googleClickIdKey = 'af_sub4';

      const afCustom = [
        { paramKey: 'af_c_id', keys: ['campaign_id'] },
        { paramKey: 'af_ad_id', keys: ['af_ad_id'] },
        { paramKey: 'af_adset_id', keys: ['af_adset_id'] },
        { paramKey: 'af_force_transparent', keys: ['af_force_transparent'] },
        { paramKey: 'af_r', keys: ['af_r'] },
        { paramKey: 'af_siteid', keys: ['af_siteid'] },
        // { paramKey: 'gclid', keys: ['gclid'] }, //альтернативный способ работы с googleClickId (возможно не рабочий)
        { paramKey: 'af_ss_ui', defaultValue: 'true' },
      ];

      const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
        oneLinkURL,
        webReferrer,
        afParameters: {
          mediaSource,
          campaign,
          adSet,
          afCustom,
          googleClickIdKey,
        },
      });

      setOneLink(result);
      console.log('OneLink URL:', result);
    }
  }, []);

  return oneLink;
};
